import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  // Section headers
  sectionHeader: {
    backgroundColor: "#FFFFFF",
    paddingVertical: 16,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#EEEEEE",
  },
  sectionHeaderText: {
    fontSize: 18,
    fontWeight: "600",
    color: "#333333",
    marginBottom: 4,
  },
  sectionHeaderDivider: {
    height: 2,
    width: 40,
    backgroundColor: "#0085FF",
    marginTop: 8,
  },
  searchResultsHeader: {
    backgroundColor: "#F5F7FA",
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#EEEEEE",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  searchResultsInfo: {
    flex: 1,
    marginRight: 8,
  },
  searchResultsTitle: {
    fontSize: 16,
    fontWeight: "500",
    color: "#333333",
  },
  searchResultsSubtitle: {
    fontSize: 14,
    color: "#666666",
    marginTop: 2,
  },
  clearSearchButton: {
    paddingHorizontal: 10,
    paddingVertical: 6,
    backgroundColor: "#EEEEEE",
    borderRadius: 4,
  },
  clearSearchText: {
    fontSize: 14,
    color: "#555555",
  },
  noResultsContainer: {
    backgroundColor: "#F9F9F9",
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#EEEEEE",
  },
  noResultsHeader: {
    padding: 20,
    backgroundColor: "#F9F9F9",
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#EEEEEE",
  },
  noResultsTitle: {
    fontSize: 18,
    fontWeight: "600",
    color: "#333333",
    marginBottom: 8,
    textAlign: "center",
  },
  noResultsText: {
    fontSize: 16,
    color: "#777777",
    textAlign: "center",
  },
  noResultsSuggestion: {
    fontSize: 14,
    color: "#888888",
    textAlign: "center",
    marginTop: 8,
    fontStyle: "italic",
  },
  sessionWarningContainer: {
    padding: 20,
    backgroundColor: "#FFF7E6",
    borderBottomWidth: 1,
    borderBottomColor: "#FFDDAE",
  },
  sessionWarningHeader: {
    marginBottom: 12,
  },
  sessionWarningTitle: {
    fontSize: 16,
    fontWeight: "600",
    color: "#B45E00",
    marginBottom: 6,
  },
  sessionWarningText: {
    fontSize: 14,
    color: "#8C5E1B",
  },
  errorContainer: {
    backgroundColor: "#FFF2F0",
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#FFCCC7",
  },
  errorHeader: {
    padding: 20,
    backgroundColor: "#FFF2F0",
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#FFCCC7",
  },
  errorTitle: {
    fontSize: 18,
    fontWeight: "600",
    color: "#e53935",
    marginBottom: 8,
    textAlign: "center",
  },
  errorText: {
    fontSize: 16,
    color: "#e53935",
    marginBottom: 16,
  },
  retryButton: {
    backgroundColor: "#e53935",
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 6,
    alignSelf: "center",
    marginTop: 12,
    marginBottom: 12,
  },
  retryButtonText: {
    color: "#FFFFFF",
    fontSize: 14,
    fontWeight: "500",
  },

  // Patient list rows
  patientListItem: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    borderBottomWidth: 1,
    borderBottomColor: "#EEEEEE",
    paddingHorizontal: 14,
    paddingVertical: 10,
    width: "100%",
    minWidth: 0,
  },
  timeColumn: {
    width: 50,
    marginRight: 12,
    alignItems: "center",
    paddingTop: 2,
  },
  timeText: {
    fontSize: 16,
    fontWeight: "600",
    color: "#333333",
  },
  amPmText: {
    fontSize: 12,
    color: "#777777",
    marginTop: 2,
  },
  patientInfoColumn: {
    flex: 1,
    justifyContent: "center",
    minWidth: 0,
  },
  patientInfoColumnDesktop: {
    justifyContent: "flex-start",
  },
  patientInfoContent: {
    flexDirection: "column",
    minWidth: 0,
  },
  patientInfoContentDesktop: {
    flexDirection: "row",
    alignItems: "stretch",
  },
  patientPrimaryInfo: {
    flexShrink: 1,
    minWidth: 0,
  },
  patientPrimaryInfoDesktop: {
    flex: 0.25,
    minWidth: 240,
    paddingRight: 4,
  },
  patientNameRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 4,
    minWidth: 0,
  },
  avatarContainer: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: "#0085FF",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 10,
  },
  avatarText: {
    fontSize: 16,
    fontWeight: "600",
    color: "#FFFFFF",
  },
  avatarImage: {
    width: "100%",
    height: "100%",
    borderRadius: 18,
  },
  patientName: {
    fontSize: 16,
    fontWeight: "500",
    color: "#333333",
    flexShrink: 1,
  },
  procedureType: {
    fontSize: 14,
    color: "#555555",
    marginBottom: 4,
  },
  searchResultItem: {
    backgroundColor: "#FAFFFE",
    borderLeftWidth: 3,
    borderLeftColor: "#4CAF50",
  },
  searchResultLabel: {
    fontSize: 11,
    color: "#4CAF50",
    fontWeight: "500",
    marginTop: 2,
  },
  searchResultTimeText: {
    fontSize: 12,
    fontWeight: "500",
    color: "#4CAF50",
    textAlign: "center",
  },
  contactInfo: {
    marginTop: 2,
    marginBottom: 2,
  },
  contactText: {
    fontSize: 12,
    color: "#666666",
    marginBottom: 2,
  },
  patientSummaryContainer: {
    marginTop: 4,
    marginBottom: 2,
    minWidth: 0,
  },
  patientSummaryContainerDesktop: {
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 4,
    flex: 0.75,
    alignSelf: "stretch",
  },
  summaryBox: {
    backgroundColor: "#f8f9fa",
    borderRadius: 6,
    paddingVertical: 8,
    paddingHorizontal: 10,
    flex: 1,
    minWidth: 0,
  },
  summaryText: {
    fontSize: 14,
    lineHeight: 18,
    color: "#333",
    fontStyle: "normal" as const,
    flexShrink: 1,
    width: "100%",
  },
});

export default styles;
